import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Actions
import { fetchUserSuggestions } from 'Shared/actions/UserSuggestions.actions';

export const useFetchUserSuggestions = () => {
  const dispatch = useDispatch();

  const [isLoading, toggleIsLoading] = useToggle(true);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    dispatch(fetchUserSuggestions()).then(response => {
      toggleIsLoading();
      setResponse(response);
    });
  }, []);

  return { isLoading, response };
};
